export const moduleConstant = {
  apiConstant: `/api/downTimeAnalysisRoute`,
  heading: 'DOWN TIME ANALYSIS REPORT',
};
